import { RecordStore } from '@deqo/foundation';
import { Bezier } from 'bezier-js';
import { injectable } from 'inversify';
import { Path } from '../../../platform/geom/Path';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';

const initialState = {
    frame: Rect.empty,
    path: new Path([['Z']]),
    dash: new Bezier([Point.zero, Point.zero, Point.zero, Point.zero]),
};

@injectable()
export class HandLayout extends RecordStore(initialState) {

    public update(frame: Rect) {

        const o = frame.pointAt(.5, 1); // Middle Bottom
        const w = 760;
        const h = 80;

        // Anchor points
        const p1 = new Point(o.x - (w / 2), o.y);
        const p2 = new Point(o.x + (w / 2), o.y);

        // Left curve
        const la = p1.add([-60, 0]);
        const lb = p1.add([-60, -(h * .4)]);
        const lc = p1.add([-60, -(h * .8)]);
        const ld = p1.add([0, -h]);

        // Right curve
        const ra = p2.add([0, -h]);
        const rb = p2.add([60, -(h * .8)]);
        const rc = p2.add([60, -(h * .4)]);
        const rd = p2.add([60, 0]);

        // Main curve
        const a = p1.add([0, -h]);
        const b = a.add(Point.vector(lc, a).normalize().multiply(w / 4));
        const d = p2.add([0, -h]);
        const c = d.add(Point.vector(rb, d).normalize().multiply(w / 4));

        const path = new Path([
            ['M', la],
            ['C', lb, lc, ld],
            ['C', b, c, d],
            ['C', rb, rc, rd],
            ['Z']
        ]);

        const dash = new Bezier([a, b, c, d]);

        this.updateState({ frame, path, dash });
    }

    public test(vpt: Point) {
        return this.path.contains(vpt);
    }
}
